import $ from "jquery";
import "slick-carousel";
import lozad from "lozad";
import AOS from "aos";
import "../../node_modules/slick-carousel/slick/slick.css";
import "../../node_modules/slick-carousel/slick/slick-theme.css";

$(function () {
	"use strict";

	$(".ImageGallery-carousel").on("init", function (event, slick) {
		const observer = lozad();
		observer.observe();
		AOS.refresh();
	});
	$(".ImageGallery-carousel").slick({
		dots: false,
		arrows: true,
		adaptiveHeight: true,
		slidesToShow: 4,
		slidesToScroll: 1,
		prevArrow: '<span class="fas fa-arrow-left"></span>',
		nextArrow: '<span class="fas fa-arrow-right"></span>',
		responsive: [
			{
				breakpoint: 900,
				settings: {
					slidesToShow: 3,
				},
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 2,
				},
			},
			{
				breakpoint: 400,
				settings: {
					slidesToShow: 1,
				},
			},
		],
	});
});
